import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../../../packages/ui/src/fonts/source-serif-4-latin-wght-normal.woff2%22,%22weight%22:%22300%20700%22,%22style%22:%22normal%22},{%22path%22:%22../../../../packages/ui/src/fonts/source-serif-4-latin-wght-italic.woff2%22,%22weight%22:%22300%20700%22,%22style%22:%22italic%22}],%22display%22:%22swap%22,%22variable%22:%22--font-source-serif%22}],%22variableName%22:%22sourceSerif%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'sourceSerif', 'sourceSerif Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
